import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./style/index.scss";
import "./style/element-variables.scss";
import "animate.css/animate.min.css";
import { Request } from "@/plugins/http";
import VueAxios from "vue-axios";
import ElementPlus from "element-plus";
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import Vant from "vant";
import "vant/lib/index.css";
import infiniteScroll from "vue-infinite-scroll";
import setDirectives from "@/views/web/directive/index"
import VConsole from "vconsole";
// const vConsole = new VConsole();

const app = createApp(App);
app.use(VueAxios, Request.init());
app.use(ElementPlus, {
  locale: zhCn,
});

createApp(App)
  .use(store)
  .use(router)
  .use(Vant)
  .use(infiniteScroll)
  .use(setDirectives)
  .mount("#app");
